module.exports = __webpack_public_path__ + "static/media/Pain Management-Medical History-1@3x.6cee112a.png";